module.exports = __webpack_public_path__ + "static/media/tutorialPrev4.11ed9962.png";